var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routeState.isMe)?_c('self-layout',{scopedSlots:_vm._u([{key:"name",fn:function(){return [_c('self-name')]},proxy:true},{key:"preferences",fn:function(){return [_c('self-preferences')]},proxy:true}],null,false,4164985033)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }